import { List, Map } from "immutable";

import { isIn } from "seneca-common/utils/functions";

import actionTypes from "../action-types";
import moduleActionTypes from "../action-types/sessionModule";
import messageActionTypes from "../features/messages/action-types";
import Session from "../models/Session";
import SessionItem, { SESSION_ITEM_TYPES } from "../models/SessionItem";
import { getLastSessionItemId } from "../selectors/state/sessions/session";

export default function sessionReducer(
  sessions = Map<string, Session>(),
  action: Record<string, any>
): Map<string, Session> {
  if (
    action.payload &&
    action.payload.sessionId &&
    isIn(action.type, {
      ...actionTypes,
      ...moduleActionTypes,
      ...messageActionTypes
    })
  ) {
    return sessions.update(action.payload.sessionId, sesh =>
      session(sesh, action)
    );
  } else {
    return sessions;
  }
}

export const session = (
  session: Session = new Session(),
  action: Record<string, any>
): Session => {
  switch (action.type) {
    case actionTypes.NEW_SESSION:
      const newSession = new Session({
        id: action.payload.sessionId,
        courseId: action.payload.courseId,
        sectionIds: List(action.payload.sectionIds),
        contentIds: List(action.payload.contentIds),
        startTime: action.payload.startTime || null,
        startingProficiency: action.payload.startingProficiency,
        startingCourseProficiency: action.payload.startingCourseProficiency,
        startingBestScore: action.payload.startingBestScore,
        sessionType: action.payload.sessionType,
        smartLearningSuggestionReason:
          action.payload.smartLearningSuggestionReason,
        completesAssignment: action.payload.completesAssignment
      });
      return newSession;
    case actionTypes.COMPLETE_SESSION:
      const {
        timeFinished,
        endingProficiency,
        endingCourseProficiency,
        endingCourseScore,
        sessionScore
      } = action.payload;
      return session.merge({
        completed: true,
        endTime: timeFinished,
        endingProficiency,
        endingCourseProficiency,
        endingCourseScore,
        sessionScore
      });

    case actionTypes.COMPLETE_NOTES_ONLY_SESSION: {
      const {
        timeFinished,
        endingCourseProficiency,
        endingCourseScore,
        endingProficiency
      } = action.payload;
      return session.merge({
        completed: true,
        endTime: timeFinished,
        endingCourseProficiency,
        endingCourseScore,
        endingProficiency
      });
    }
    case moduleActionTypes.NEW_SESSION_MODULE:
      return session
        .update("items", items =>
          items.push(
            new SessionItem({
              // @ts-ignore
              type: SESSION_ITEM_TYPES.MODULE,
              id: action.payload.sessionModuleId
            })
          )
        )
        .set("focusedItemId", action.payload.sessionModuleId);
    case messageActionTypes.NEW_SESSION_MESSAGE:
      return session
        .update("items", items =>
          items.push(
            new SessionItem({
              // @ts-ignore
              type: SESSION_ITEM_TYPES.MESSAGE,
              id: action.payload.sessionMessageId
            })
          )
        )
        .set("focusedItemId", action.payload.sessionMessageId);
    case actionTypes.RECONCILE_SESSION_PROFICIENCIES:
      const { sessionId, ...proficiencies } = action.payload;
      return session.merge({ ...proficiencies });
    case actionTypes.SET_WON_MEMORY:
      return session.set("wonMemory", action.payload.wonMemory);
    case actionTypes.FOCUS_ITEM:
      return session.set("focusedItemId", action.payload.itemId);
    case actionTypes.FOCUS_LAST_ITEM:
      return session.set("focusedItemId", getLastSessionItemId(session));
    case actionTypes.UPDATE_SESSION_XP:
      return session.set("xp", action.payload.xp);
    default:
      return session;
  }
};
